import React from 'react';
import { ArrowRightIcon, CalendarIcon, ArrowUpRightIcon } from 'lucide-react';
export const CTABanner = () => {
  return <section className="py-14 md:py-20 bg-white text-black" data-id="element-108">
      <div className="container mx-auto px-6 text-center" data-id="element-109">
        <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-110">
          Ready to maximize your sponsorship revenue?
        </h2>
        <p className="text-xl text-black/70 max-w-3xl mx-auto mb-8 md:mb-10 leading-relaxed" data-id="element-111">
          Our clients typically see a 30-45% increase in sponsorship revenue
          within their first event cycle.
        </p>
        <div className="flex flex-col sm:flex-row gap-5 justify-center" data-id="element-112">
          <a href="https://calendar.app.google/UHmu8gqmNjGApsL99" className="inline-flex items-center justify-center gap-3 bg-[#FF7A39] hover:bg-[#FF7A39]/90 text-black px-6 py-3.5 md:px-8 md:py-4 rounded-md font-medium text-lg transition-all shadow-md w-full sm:w-auto" data-id="element-113">
            <CalendarIcon size={20} data-id="element-114" />
            Schedule a Free Consultation
          </a>
          <a href="#resources" className="inline-flex items-center justify-center gap-3 bg-transparent border border-black/20 text-black px-6 py-3.5 md:px-8 md:py-4 rounded-md font-medium text-lg hover:bg-black/5 transition-all shadow-sm w-full sm:w-auto" data-id="element-115">
            Explore Resources <ArrowUpRightIcon size={20} data-id="element-116" />
          </a>
        </div>
      </div>
    </section>;
};